const initialState = () => {
    return {
        /**
         * @description
         * State of a Client associated to a single transaction
         */

        // The next properties are the properties from a DB Client Object
        customerData: {
            id: '',
            rut: '',
            businessName: '',
            personName: '',
            coreBusiness: '',
            address: '',
            phone: '',
            email: '',
        },
        coreBusinessSelected: null,
        activeOfficeID: null,

        createMode: false,

        // Discounts state
        acailableDiscounts: {
            // Object containing available discounts for this Client, if any
        },

        /**
         * @description
         * this prop returns the state of the current Client stored data.
         * If value is  null, there's not enough info to generate a quotation or invoice
         * If value is 'quotation', there's enough info to generate a quotation, but not an invoice
         * If value is 'invoice', there's enough info to generate a quotation or an invoice
         */
        dataStatus: null, // READY: should change value to null,

        branchOffices: [],
        selectedOffice: null,
        customerReadonly: false,
        customerPaymentConditionId: null,
    }
}

export default initialState
